import { RelativeDatetime } from "~/ui/relative-date"
import { UserAvatar } from "~/users/user-avatar"
import { type User } from "~/__generated__/graphql"

type BaseCommentProps = {
  user: Pick<User, "fullName"> & Parameters<typeof UserAvatar>[0]["user"]
  createdAt: string
  body: string
}

type CommentProps = BaseCommentProps & {
  actions?: React.ReactNode
}

export const Comment: React.FC<CommentProps> = ({ user, createdAt, body, actions }) => {
  return (
    <div className="flex gap-4">
      <UserAvatar user={user} size="sm" />
      <div className="flex-1">
        <div className="mb-2 mt-1 flex items-center justify-between">
          <div className="flex h-4 items-center">
            <span className="text-xs">{user.fullName}</span>
            {actions && <div className="ms-4">{actions}</div>}
          </div>
          <div className="flex items-center gap-2 text-xs text-gray-600">
            <RelativeDatetime input={createdAt} />
          </div>
        </div>
        <p className="mt-1 whitespace-pre text-sm text-gray-600">{body}</p>
      </div>
    </div>
  )
}
